import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/invoices/areAutomaticRemindersEnabled`;

export const ROUTE: RouteDefinition = `${baseRoute}/invoices/areAutomaticRemindersEnabled`;

export const URL = (): RouteDefinition => `${baseRoute}/invoices/areAutomaticRemindersEnabled`;
